import { render } from "./StudentDetail.vue?vue&type=template&id=59161578&scoped=true"
import script from "./StudentDetail.vue?vue&type=script&lang=js"
export * from "./StudentDetail.vue?vue&type=script&lang=js"

import "./StudentDetail.vue?vue&type=style&index=0&id=59161578&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59161578"]])

export default __exports__